(function($, Drupal) {
  Drupal.behaviors.webform_custom = {
    attach: function(context, settings) {
      const updateSchoolOptions = function(type, zip, value = '') {
        $.get('/unicef-schools/lookup/' + type + '/' + zip, function(data) {
          if (data.data) {
            let $schools = $('#edit-club-school-name');
            $schools.empty();
            $schools.append($('<option></option').attr('value', '').attr('attr-id', 'none').text(''));
            $.each(data.data, function(key, school) {
              $schools.append($('<option></option').attr('value', school.name).attr('attr-id', school.id).attr('attr-metro', school.metro).text(school.name));
            });
            $schools.val(value);
          }
        });
      };
      $(window).on('load', function(e) {
        if (!isNaN($('#edit-club-zip').val()) && $('#edit-club-zip').val().length === 5) {
          updateSchoolOptions($('#edit-club-type').val(), $('#edit-club-zip').val(), $('input:hidden[name=school_name_placeholder]').val());
        }
      });
      if ($('.webform-submission-club-registration-add-form').length > 0) {
        $('#edit-club-zip').on('input change', function(e) {
          if (!isNaN($(this).val()) && $(this).val().length === 5) {
            updateSchoolOptions($('#edit-club-type').val(), $(this).val());
          }
        });
        $('#edit-club-school-name').on('change', function(e) {
          $('input:hidden[name=school_unique_id]').val($(this).find(':selected').attr('attr-id'));
          $('input:hidden[name=school_metro]').val($(this).find(':selected').attr('attr-metro'));
          $('input:hidden[name=school_name_placeholder]').val($(this).find(':selected').val());
        });
        $('#edit-club-type').on('change', function(e) {
          if (!isNaN($('#edit-club-zip').val()) && $('#edit-club-zip').val().length === 5) {
            updateSchoolOptions($(this).val(), $('#edit-club-zip').val());
          }
        });
        $('#edit-new-school-zip').on('input change', function(e) {
          if (!isNaN($(this).val()) && $(this).val().length === 5) {
            $.get('/unicef-schools/metro/' + $(this).val(), function(data) {
              if (data.data) {
                $('input:hidden[name=school_metro]').val(data.data[0].metro);
              }
            });
          }
        });
      }

      if ($('.webform-submission-club-donation-add-form').length > 0 || $('.webform-submission-club-contacts-alt-add-form').length > 0) {
        $('#edit-club-zip').on('input change', function(e) {
          if (!isNaN($(this).val()) && $(this).val().length === 5) {
            updateSchoolOptions($('#edit-club-type').val(), $(this).val());
            $('#edit-club-school-name').change();
          }
        });
        $('#edit-club-school-name').on('change', function(e) {
          $('input:hidden[name=school_unique_id]').val($(this).find(':selected').attr('attr-id'));
          $.get('/unicef-schools/clubs/' + $(this).find(':selected').attr('attr-id'), function(data) {
            if (data.data.length > 0) {
              let $clubs = $('#edit-club-name');
              $clubs.empty();
              $clubs.append($('<option></option').attr('value', '').attr('attr-id', 'none').text(''));
              $.each(data.data, function(key, club) {
                $clubs.append($('<option></option').attr('value', 'UNICEF Club ' + club.year).attr('attr-id', club.id).text('UNICEF Club ' + club.year));
              });
            }
            else {
              $('#edit-club-name').empty().append($('<option></option').attr('value', '').attr('attr-id', 'none').text('No Clubs Found'));
            }
          });
        });
        $('#edit-club-type').on('change', function(e) {
          if (!isNaN($('#edit-club-zip').val()) && $('#edit-club-zip').val().length === 5) {
            updateSchoolOptions($(this).val(), $('#edit-club-zip').val());
            $('#edit-club-name').empty().append($('<option></option').attr('value', '').attr('attr-id', 'none').text(''));
          }
        });
        $('#edit-club-name').on('change', function(e) {
          $('input:hidden[name=club_id]').val($(this).find(':selected').attr('attr-id'));
        });
      }
      if ($('.webform-submission-club-contacts-form').length > 0) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const clubid = urlParams.get('club');
        $.get('/unicef-schools/school/' + clubid, function(data) {
          if (data.data.length > 0) {
            $('span.schoolName').html('<strong>' + data.data[0].name + '</strong>');
          }
        });
      }

      if ($('#edit-page-2').find('input[name="school_name"]').length > 0) {
        $('#school-name').text($('#edit-page-2').find('input[name="school_name"]').val());
      }

      if ($('.webform-submission-idp-soccor-tournament-form').length > 0 && $('.webform-confirmation__message').length > 0) {
        window.setTimeout(function(){
            window.location.href = "/about-unicef-usa/partnerships/supporters/sports-partnerships/soccer-tournament";
        }, 2000);
      }
      
      if ($('.webform-submission-inter-miami-cf-930-form').length > 0 && $('.webform-confirmation__message').length > 0) {
        window.setTimeout(function(){
            window.location.href = "/about-unicef-usa/partnerships/supporters/sports-partnerships/imcf930";
        }, 2000);
      }

      $('#trigger-prev').on('click', function(e) {
        e.preventDefault();
        $('#edit-wizard-prev').trigger('click');
      });

      if ($('.iti__flag-container')) {
        $('.iti__selected-flag').removeAttr('role');

        $('.iti__flag-container').on('change', function(e) {
          // Remove an anttribute from '.iti__selected-flag'
          $('.iti__selected-flag').removeAttr('role');
        });
      }

      // Move submit button inside a wrapper around the email input for subscribe forms
      $('.webform-submission-subscribe-form, .webform-submission-subscribe-with-phone-number-form').each(function() {
        var $form = $(this);
        var $emailInput = $form.find('input[type="email"]').first();
        var $formActions = $form.find('.form-actions');

        if ($emailInput.length && $formActions.length) {
          $emailInput.wrap('<div class="email-input-wrapper"></div>');
          var $wrapper = $emailInput.parent('.email-input-wrapper');
          $wrapper.append($formActions);
        }
      });
    }
  };
})(jQuery, Drupal);